"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSWordNormalizer = void 0;
const normalizer_1 = require("./normalizer");
Object.defineProperty(exports, "MSWordNormalizer", { enumerable: true, get: function () { return normalizer_1.MSWordNormalizer; } });
